var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('a',{staticClass:"text-inherit hover:text-primary",on:{"click":function($event){return _vm.copyText(_vm.params.value)}}},[_vm._v(_vm._s(_vm.params.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }